import { Link } from '@chakra-ui/react'
import React from 'react'

const LinkCreate = ({title}) => {
  return (
    <Link style={{marginRight:"15px"}}>{title}</Link>
  )
}

export default LinkCreate
